import {
  BlockStack,
  Box,
  InlineStack,
  ProgressBar,
} from "@shopify/polaris";
import CommonTableFilterSkeletonList from "./CommonTableFilterSkeletonList";
const Index = () => {
  return (
    <div>
      <BlockStack gap="300" direction="cloumn">
        <InlineStack gap={100} align="space-between">
          <Box style={{width:"200px"}}>
          <ProgressBar size="large"/>
          </Box>
          <Box>
          <InlineStack gap={200}>
            <Box style={{width:'100px'}}>
          <ProgressBar size="large"/>
            </Box>
            <Box style={{width:'100px'}}>
          <ProgressBar size="large"/>
            </Box>
          </InlineStack>
          </Box>
        </InlineStack>
        <CommonTableFilterSkeletonList />
      </BlockStack>
      </div>
  );
};

export default Index;
